import React, { useState } from 'react'
import Nav from '../components/Nav'
import MobileNav from '../components/MobileNav'
import { graphql } from 'gatsby'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import HomeSection from '../components/HomeSection'
import AboutSection from '../components/AboutSection'
import ServicesSection from '../components/ServicesSection'
import ExpSection from '../components/ExpSection'
import ReviewsSection from '../components/ReviewsSection'
import BlogSection from '../components/BlogSection'
import ContactSection from '../components/ContactSection'

import Layout from '../layouts/layout'
import SEO from '../components/Seo'

export default function Home ({ data }) {
  const [currentSection, setCurrentSection] = useState('section1')
  const { t } = useTranslation()

  return (
    <Layout props={data}>
      <SEO
        title="Alexandre Lion - Freelance Developer"
        description={t('seo.description')}
        keywords={t('seo.keywords')}
      />
      <Nav currentSection={currentSection} />
      <MobileNav currentSection={currentSection} />
      <div className="lg:ml-32">
        <HomeSection
          onSectionChange={(s) => {
            setCurrentSection(s)
          }}
          currentSection={currentSection}
        />
        <AboutSection
          onSectionChange={(s) => {
            setCurrentSection(s)
          }}
          currentSection={currentSection}
        />
        <ServicesSection
          onSectionChange={(s) => {
            setCurrentSection(s)
          }}
          currentSection={currentSection}
        />
        <ExpSection
          onSectionChange={(s) => {
            setCurrentSection(s)
          }}
          currentSection={currentSection}
        />
        <ReviewsSection
          onSectionChange={(s) => {
            setCurrentSection(s)
          }}
          currentSection={currentSection}
        />
        <BlogSection
          onSectionChange={(s) => {
            setCurrentSection(s)
          }}
          blogPosts={data.posts}
          currentSection={currentSection}
        />
        <ContactSection
          onSectionChange={(s) => {
            setCurrentSection(s)
          }}
          currentSection={currentSection}
        />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($language: String!) {
    posts: allMediumPost(limit: 3, sort: { fields: [createdAt], order: DESC }) {
      edges {
        node {
          id
          title
          createdAt
          uniqueSlug
          virtuals {
            subtitle
            previewImage {
              imageId
            }
          }
          author {
            name
          }
        }
      }
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
